/**
 * OnFire Hockey — Navigation
 * Mobile menu toggle, smooth scroll, active state
 */
(function () {
  'use strict';

  var hamburger = document.getElementById('navbar-hamburger');
  var closeBtn = document.getElementById('navbar-close');
  var mobileMenu = document.getElementById('navbar-mobile-menu');
  var body = document.body;

  var iconOpen = document.getElementById('hamburger-icon-open');
  var iconClose = document.getElementById('hamburger-icon-close');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    body.style.overflow = 'hidden';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    if (iconOpen) iconOpen.style.display = 'none';
    if (iconClose) iconClose.style.display = '';
  }

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    body.style.overflow = '';
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    if (iconOpen) iconOpen.style.display = '';
    if (iconClose) iconClose.style.display = 'none';
  }

  if (hamburger) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileMenu && mobileMenu.classList.contains('is-open');
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }

  // Close mobile menu on link click
  if (mobileMenu) {
    var links = mobileMenu.querySelectorAll('a');
    links.forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  // Close on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
    }
  });

  // Smooth scroll for anchor links — only when href is a valid in-page selector
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var hash = this.getAttribute('href');
      if (!hash || hash === '#' || hash.length < 2) return;
      try {
        var target = document.querySelector(hash);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } catch (err) {
        // Invalid selector — let default behavior run
      }
    });
  });
})();
